<template>
  <div>
<!--    <page-header></page-header>-->
    <popup-header @clickClose="closeModal()" :headerBg="'grey'" />
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col
        cols="12"
        class="icon-title word-type-txt pb-4 d-flex justify-space-between"
      >
        <div><icon-application :width="24" :height="24" />{{currentYmd}} 부서 근태/휴가 현황</div>
      </v-col>
    </v-row>
<!--    <v-row>-->
<!--      <v-col>12.29(금)</v-col>-->
<!--    </v-row>-->
<!--    <v-row class="title-wrap">-->
<!--      <v-col class="bg-title">연차</v-col>-->
<!--    </v-row>-->

    <!-- 근태현황 리스트 -->
    <v-container>
      <v-list subheader v-for="(item, idx) in searchList" :key="idx">
        <v-list-item-title class="grey lighten-3 pt-2 pb-2">
          <v-icon>mdi-circle-small</v-icon> {{item.orgNm}}
        </v-list-item-title>
        <v-list-item v-for="(detail, ix) in item.orgList" :key="ix">
          {{detail.name}} ({{detail.gntNm}})
        </v-list-item>
      </v-list>
    </v-container>

<!--    <v-list flat class="doc-list">-->
<!--      <v-list-item-group>-->
<!--        <v-list-item-->
<!--          v-for="item in searchList"-->
<!--          :key="item.applSeq"-->
<!--          class="doc-list-divider"-->
<!--        >-->
<!--          <v-list-item-icon class="avatar-wrap">-->
<!--            <v-avatar size="52" class="with-icon bg-grey">-->
<!--              &lt;!&ndash; 신청서에 따라 아이콘 변경 &ndash;&gt;-->
<!--              <appl-menu-icon-->
<!--                :propsParam="{-->
<!--                  applCd: item.applCd,-->
<!--                  gntGubunCd: item.gubunCd,-->
<!--                }"-->
<!--                :styleClassStr="'mr-0'"-->
<!--              ></appl-menu-icon>-->
<!--            </v-avatar>-->
<!--          </v-list-item-icon>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title class="doc-title">{{-->
<!--              item.title-->
<!--            }}</v-list-item-title>-->
<!--            <v-list-item-subtitle>-->
<!--              <div class="attendance-subtext">-->
<!--                <span class="company">BGF</span>-->
<!--                <span class="divider"></span>-->
<!--                <span class="team">IT기획팀</span>-->
<!--              </div>-->
<!--            </v-list-item-subtitle>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->
<!--      </v-list-item-group>-->
<!--    </v-list>-->
  </div>
</template>

<script>
/* 내 신청서 리스트 컴포넌트 */
import EmptyData from '@/components/common/EmptyData.vue';
import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';
import dayjs from 'dayjs';
import messageConstants from '@/const/messageConstants.js';
import { getMyBoxList } from '@/api/allDoc.js';
import { mapGetters } from 'vuex';
import routerNames from '@/const/routerConstants';
import IconApplication from '@/assets/customIcon/IconApplication.vue';
import PageHeader from '@/components/common/PageHeader.vue';
import PopupHeader from "@/components/common/PopupHeader.vue";
import dialogMixin from "@/mixins/dialogMixin";
import { getOrgGntWorkStaPsnlCalendarMonList } from '@/api/calendar.js';

export default {
  mixins: [dialogMixin],
  props: {
    // // 조회요청구분 (MYDOC:내문서, TEMP:임시저장문서, CANCEL:취소신청문서)
    // searchReqGubun: {
    //   type: String,
    // },
    // // 조회신청서코드 (근태취소신청, 보상휴가취소신청일때만 전달)
    // searchApplCd: {
    //   type: String,
    //   default: '',
    // },
    currentYmd : {type : String}
  },
  data() {
    return {
      emptyDataFlag: false, // 조회결과없음 플래그
      searchList: [],
      emptyDataText: messageConstants.emptyDataMsg_1,
      modalName : 'attendance_sta'
    };
  },
  computed: {
    ...mapGetters('DIALOG', ['GET_DIALOG_CALLBACK']),
    stepChipClass() {
      return applStatusCd => {
        return {
          // 신청서상태코드 (21,31,98:결재처리중,수신처리중,승인요청중 / 23,33:결재반려,수신반려 / 99:처리완료)
          draft: applStatusCd == 23 || applStatusCd == 33,
          charge:
            applStatusCd == 21 || applStatusCd == 31 || applStatusCd == 98,
          approval: applStatusCd == 99,
        };
      };
    },
  },
  watch: {
    GET_DIALOG_CALLBACK(callback) {
      if (callback) {
        this.fetchMyBoxList();
      }
    },
  },
  methods: {
    /* 내문서함 목록조회 */
    async fetchMyBoxList() {
      const userData = this.$store.getters.GET_USER_DATA;
      const startYm = this.currentYmd.substring(0, 4) + this.currentYmd.substring(5,7)
      getOrgGntWorkStaPsnlCalendarMonList({
        enterCd : userData.ssnEnterCd
        , sabun : userData.ssnSabun
        , startYm : startYm
        , currentYmd : this.currentYmd
      }).then((response) => {
        //정렬
        const data = response.data.data.attendanceList;
        this.searchList = [];
        for(let i=0; i<data.length; i++){
          let orgObj = this.checkOrg(data[i]);
          orgObj.orgList.push(data[i]);
          // this.searchList.push(orgObj);
        }
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER'); // 공통 스피너 OFF
      });
    },
    checkOrg(data){
      let result;
      for(let i=0; i<this.searchList.length; i++){
        if(this.searchList[i].orgCd === data.orgCd){
          result = this.searchList[i];
        }
      }
      if(!result){
        result = {orgCd : data.orgCd, orgNm : data.orgNm, orgList : []};
        this.searchList.push(result);
      }
      return result;
    },
    closeModal() {
      // this.toggleModal();
      // // 모든 모달이 닫혔을때만 뒤로가기
      // if (this.GET_DIALOG_STACK_SIZE === 0) {
      //   history.go(-1);
      // }
      this.$emit('close');
    },
    /* 모달 닫기 */
    toggleModal() {
      if (this.dialog) {
        this.$store.commit('DIALOG/TOGGLE_MODAL', this.modalName);
        this.OFF_APP_SPINNER();
      }
    }
  },
  beforeCreate() {
    this.$store.commit('SPINNER/ON_COMMON_SPINNER');
  },
  created() {
    this.fetchMyBoxList();
  },
  components: {
    PopupHeader,
    PageHeader,
    IconApplication,
    EmptyData,
    ApplMenuIcon,
  },
};
</script>
